module.exports = __webpack_public_path__ + "img/reference-zapfigshop.c6f654a4.webp";